import React from 'react';
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Box,
  Typography,
  Chip,
  Alert,
} from '@mui/material';
import {
  Group as GroupIcon,
  PersonAdd as PersonAddIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

const SelectSourceStep = ({ sourceType, onSelectSource, companyName, errors }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Select Source
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        Choose how to add a director to <strong>{companyName || 'the selected company'}</strong>
      </Typography>

      {errors?.sourceType && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errors.sourceType}
        </Alert>
      )}

      {/* Company Context */}
      <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Adding director to:
        </Typography>
        <Typography variant="body1" fontWeight={600}>
          {companyName}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              border: sourceType === 'pool' ? '2px solid' : '1px solid',
              borderColor: sourceType === 'pool' ? 'primary.main' : 'divider',
              bgcolor: sourceType === 'pool' ? 'primary.50' : 'background.paper',
              position: 'relative',
            }}
          >
            {sourceType === 'pool' && (
              <CheckIcon
                sx={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  color: 'primary.main',
                  fontSize: 24,
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              />
            )}
            <CardActionArea onClick={() => onSelectSource('pool')} sx={{ p: 2 }}>
              <CardContent>
                <Box textAlign="center">
                  <GroupIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    From Pool
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    Select an existing director from another company
                  </Typography>
                  <Chip
                    label="Recommended for shared directors"
                    size="small"
                    color="primary"
                    variant="outlined"
                    onClick={(e) => e.stopPropagation()}
                  />
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card
            sx={{
              border: sourceType === 'new' ? '2px solid' : '1px solid',
              borderColor: sourceType === 'new' ? 'primary.main' : 'divider',
              bgcolor: sourceType === 'new' ? 'primary.50' : 'background.paper',
              position: 'relative',
            }}
          >
            {sourceType === 'new' && (
              <CheckIcon
                sx={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  color: 'primary.main',
                  fontSize: 24,
                  zIndex: 1,
                  pointerEvents: 'none',
                }}
              />
            )}
            <CardActionArea onClick={() => onSelectSource('new')} sx={{ p: 2 }}>
              <CardContent>
                <Box textAlign="center">
                  <PersonAddIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Create New
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    Add a new director to the system
                  </Typography>
                  <Chip
                    label="For new directors"
                    size="small"
                    color="success"
                    variant="outlined"
                    onClick={(e) => e.stopPropagation()}
                  />
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectSourceStep;
